// Hilfen für WhatsApp-Versand aus dem Adminbereich
export const waNummer = (tel = "") => {
  const d = String(tel).replace(/[^\d+]/g, "").replace(/^\+/, "");
  if (!d) return "";
  if (d.startsWith("00")) return d.slice(2);
  if (d.startsWith("49")) return d;
  if (d.startsWith("0")) return "49" + d.slice(1);
  return d;
};

export const waOeffnen = (tel, text) => {
  const nr = waNummer(tel);
  const url = `https://wa.me/${nr}?text=${encodeURIComponent(text)}`;
  window.open(url, "_blank", "noopener");
  return !!nr;
};

export const rechnungWaText = ({ ansprechpartner = "", nummer = "", url = "" }) =>
  `Guten Tag${ansprechpartner ? " " + ansprechpartner : ""},\n\n` +
  `vielen Dank für den Einsatz. Ihre Rechnung${nummer ? " " + nummer : ""} liegt bereit — ` +
  `über diesen Link können Sie sie jederzeit ansehen und als PDF herunterladen:\n\n${url}\n\n` +
  `Herzliche Grüße\nLukas Stutz`;
